

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Skeleton,
  Stack,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BadgeIcon from "@mui/icons-material/Badge";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupsIcon from "@mui/icons-material/Groups";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import axios from "axios";
import ApiCallService from "../../../Service/ApiCallService";
import Spinner from "../../../components/common/Spinner";
import ReactTable from "../../../components/common/ReactTable";

const SingleChapterView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [chapter, setChapter] = useState(null);
  const [members, setMembers] = useState([]);

 useEffect(() => {
  const loadData = async () => {
    await fetchChapter();
    await fetchMembers();
  };

  loadData();
}, [id]);

  const fetchChapter = async () => {
    try {
      setLoading(true);
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/getChapterById/${id}`
      );
      setChapter(res?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMembers = async () => {


    try {
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/membersByChapter/${id}`
      );
      setMembers(res.data || []);
    } catch (err) {
      console.error(err);
    }


  };




  if (loading ) {
    return (
      <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } , bgcolor: "#c55b5b", minHeight: "100vh"}}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Skeleton variant="rounded" width={96} height={38} />
            <Box sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="35%" height={34} />
              <Skeleton variant="text" width="22%" height={22} />
            </Box>
            <CircularProgress size={28} />
          </Stack>

          <Grid container spacing={2.5}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item}>
                <Skeleton variant="rounded" height={120} sx={{ borderRadius: 3 }} />
              </Grid>
            ))}
            <Grid item xs={12} md={7}>
              <Skeleton variant="rounded" height={260} sx={{ borderRadius: 3 }} />
            </Grid>
            <Grid item xs={12} md={5}>
              <Skeleton variant="rounded" height={260} sx={{ borderRadius: 3 }} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }




  const loc = chapter?.location || {};
  const chapterAddress = chapter?.chapterAddress || loc.chapterAddress || "-";

  const getStatusColor = (status) => {
    const value = `${status || ""}`.toLowerCase();
    if (value.includes("active") || value.includes("approved")) return "success";
    if (value.includes("pending") || value.includes("progress")) return "warning";
    if (value.includes("inactive") || value.includes("reject") || value.includes("closed")) return "error";
    return "primary";
  };



  const locationItems = [
    { label: "State", value: loc.state?.stateName || "-" },
    { label: "Region", value: loc.region?.regionName || "-" },
    { label: "District", value: loc.district?.districtName || "-" },
    { label: "Taluka", value: loc.taluka?.talukaName || "-" },
    { label: "Village", value: loc.village?.villageName || "-" },
  ];

  const chapterStatusOptions = ["Prospective", "Vibrant"];

  const memberColumns = [
    { field: "memberName", headerName: "Member Name" },
    { field: "contact", headerName: "Contact" },
    { field: "role", headerName: "Role" },
  ];

  const memberRows = (members || []).map((m) => ({
    memberName: `${m.user?.userFirstName || ""} ${m.user?.userLastName || ""}`.trim() || "-",
    contact: m.user?.mobileNumber || m.user?.mobile || "-",
    role: m.role?.name || m.roleName || "-",
    _id: m._id,
  }));

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#fff", py: { xs: 2, md: 4 } }}>
      <Container maxWidth="xl">
        <Spinner loading={loading} />

        <Paper
          elevation={0}
          sx={{
            mb: 3,
            p: { xs: 2, md: 3 },
          //  borderRadius: 3,
        //    border: "1px solid",
       //     borderColor: "divider",
         //   background: "linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)",
          }}
        >
          <Box sx={{ position: "relative", minHeight: 56 }}>
            <Box sx={{ position: "absolute", left: 8, top: 8 }}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              >
                Back
              </Button>
            </Box>

            <Box sx={{ position: "absolute", left: "50%", top: 12, transform: "translateX(-50%)" }}>
              <Typography variant="h4" sx={{ fontWeight: 700, color: "text.primary", textAlign: "center" }}>
                View Chapter
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={{ mb: 3, p: { xs: 2, md: 3 }, borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              borderBottom: "2px solid #eee",
              pb: 1,
            }}
          >
            Chapter Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Chapter Name"
                value={chapter?.chapterName || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Chapter Unique Code"
                value={chapter?.chapterUniqueCode || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                select
                label="Chapter Status"
                value={chapter?.chapterLifecycleStatus || ""}
                disabled
              >
                {chapterStatusOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ mb: 3, p: { xs: 2, md: 3 }, borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              borderBottom: "2px solid #eee",
              pb: 1,
            }}
          >
            Location Details
          </Typography>

          <Grid container spacing={2}>
            {locationItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.label}>
                <TextField
                  fullWidth
                  label={item.label}
                  value={item.value}
                  disabled
                />
              </Grid>
            ))}
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                label="Chapter Address"
                value={chapterAddress}
                multiline
                rows={2}
                disabled
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ mb: 3, p: { xs: 2, md: 3 }, borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 2,
              borderBottom: "2px solid #eee",
              pb: 1,
            }}
          >
            Chapter Members
          </Typography>

          {members.length === 0 ? (
            <Box
              sx={{
                py: 6,
                px: 2,
                textAlign: "center",
                borderRadius: 3,
                bgcolor: "#f8fafc",
                border: "1px dashed",
                borderColor: "divider",
              }}
            >
              <Avatar sx={{ mx: "auto", mb: 1.5, bgcolor: "background.paper", color: "text.secondary" }}>
                <GroupsIcon />
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                No members found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Members will appear here once they are assigned to this chapter.
              </Typography>
            </Box>
          ) : (
            <Box>
              <ReactTable columns={memberColumns} rows={memberRows} rowKey="_id" initialOrderBy="" />
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default SingleChapterView;
